<template>
  <div>
    <div v-if="showFlag">
      <el-form :inline="true" :model="searchForm">
        <el-row :gutter="20">
          <el-form-item :label="$t('fitnessProject.projectName')">
            <el-input v-model="searchForm.xiangmumingcheng" :placeholder="$t('fitnessProject.projectName')" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('fitnessProject.projectType')">
            <el-select v-model="searchForm.xiangmuleixing" :placeholder="$t('fitnessProject.selectProjectType')" @change="xiangmuleixingChange" clearable>
              <el-option
                v-for="(item, index) in xiangmuleixingOptions"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="search()">{{ $t('common.search') }}</el-button>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item>
            <el-button type="success" @click="addOrUpdateHandler()">{{ $t('common.add') }}</el-button>
            <el-button
              type="danger"
              :disabled="dataListSelections.length <= 0"
              @click="deleteHandler()"
            >{{ $t('common.delete') }}</el-button>
            <el-button type="warning" @click="createAllAssociations()">{{ $t('fitnessProject.createAllAssociations') }}</el-button>
          </el-form-item>
        </el-row>
      </el-form>

      <el-table :data="dataList" v-loading="dataListLoading" @selection-change="selectionChangeHandler">
        <el-table-column v-if="contents.tableSelection" type="selection" width="50"></el-table-column>
        <el-table-column v-if="contents.tableIndex" type="index" :label="$t('common.index')" width="50"></el-table-column>
        <el-table-column prop="xiangmumingcheng" :label="$t('fitnessProject.projectName')"></el-table-column>
        <el-table-column prop="xiangmuleixing" :label="$t('fitnessProject.projectType')"></el-table-column>
        <el-table-column prop="jianshenshipin" :label="$t('fitnessProject.fitnessVideo')">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="download($base.imgurl + scope.row.jianshenshipin)">{{ $t('common.preview') }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="xiangmutupian" :label="$t('fitnessProject.projectImage')" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.xiangmutupian">
              <img :src="$base.imgurl + scope.row.xiangmutupian.split(',')[0]" width="100" height="100" />
            </div>
            <div v-else>{{ $t('common.noImage') }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="durationMinutes" :label="$t('fitnessProject.duration')">
          <template slot-scope="scope">{{ scope.row.durationMinutes }}</template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" width="300">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="addOrUpdateHandler(scope.row.id, 'info')">{{ $t('common.detail') }}</el-button>
            <el-button type="primary" size="mini" @click="addOrUpdateHandler(scope.row.id)">{{ $t('common.edit') }}</el-button>
            <el-button type="danger" size="mini" @click="deleteHandler(scope.row.id)">{{ $t('common.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="Number(contents.pageEachNum)"
        :total="totalPage"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>

    <add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
  </div>
</template>

<script>
import axios from 'axios'
import AddOrUpdate from "./add-or-update";
export default {
  data() {
    return {
      xiangmuleixingOptions: [],
      searchForm: {
        key: ""
      },
      form:{},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      sfshVisiable: false,
      shForm: {},
      chartVisiable: false,
      addOrUpdateFlag:false,
      contents: {
        tableSelection: true,  // 是否显示选择列
        tableIndex: true,      // 是否显示序号列
        pageEachNum: 10,        // 默认分页数量
        searchBtnFont: "1",    // 1 表示显示"查询"按钮文本
        btnAdAllFont: "1",      // 1 表示显示"新增"和"删除"按钮文本
        tableBtnFont: "1"      // 1 表示显示表格操作按钮的文本（详情、修改、删除）
      },
      layouts: '',

project: {},
      coaches: [],
      // showFlag: true,
      detailViewFlag: false,

    };
  },
  created() {
    this.init();
    this.getDataList();
    this.contentStyleChange()
  },
  mounted() {

  },
  filters: {
    htmlfilter: function (val) {
      return val.replace(/<[^>]*>/g).replace(/undefined/g,'');
    }
  },
  components: {
    AddOrUpdate,
  },
  methods: {
    

    contentStyleChange() {
      this.contentSearchStyleChange()
      this.contentBtnAdAllStyleChange()
      this.contentSearchBtnStyleChange()
      this.contentTableBtnStyleChange()
      this.contentPageStyleChange()
    },
    contentSearchStyleChange() {
      this.$nextTick(()=>{
        document.querySelectorAll('.form-content .slt .el-input__inner').forEach(el=>{
          let textAlign = 'left'
          if(this.contents.inputFontPosition == 2) textAlign = 'center'
          if(this.contents.inputFontPosition == 3) textAlign = 'right'
          el.style.textAlign = textAlign
          el.style.height = this.contents.inputHeight
          el.style.lineHeight = this.contents.inputHeight
          el.style.color = this.contents.inputFontColor
          el.style.fontSize = this.contents.inputFontSize
          el.style.borderWidth = this.contents.inputBorderWidth
          el.style.borderStyle = this.contents.inputBorderStyle
          el.style.borderColor = this.contents.inputBorderColor
          el.style.borderRadius = this.contents.inputBorderRadius
          el.style.backgroundColor = this.contents.inputBgColor
        })
        if(this.contents.inputTitle) {
          document.querySelectorAll('.form-content .slt .el-form-item__label').forEach(el=>{
            el.style.color = this.contents.inputTitleColor
            el.style.fontSize = this.contents.inputTitleSize
            el.style.lineHeight = this.contents.inputHeight
          })
        }
        setTimeout(()=>{
          document.querySelectorAll('.form-content .slt .el-input__prefix').forEach(el=>{
            el.style.color = this.contents.inputIconColor
            el.style.lineHeight = this.contents.inputHeight
          })
          document.querySelectorAll('.form-content .slt .el-input__suffix').forEach(el=>{
            el.style.color = this.contents.inputIconColor
            el.style.lineHeight = this.contents.inputHeight
          })
          document.querySelectorAll('.form-content .slt .el-input__icon').forEach(el=>{
            el.style.lineHeight = this.contents.inputHeight
          })
        },10)

      })
    },
    // 搜索按钮
    contentSearchBtnStyleChange() {
      this.$nextTick(()=>{
        document.querySelectorAll('.form-content .slt .el-button--success').forEach(el=>{
          el.style.height = this.contents.searchBtnHeight
          el.style.color = this.contents.searchBtnFontColor
          el.style.fontSize = this.contents.searchBtnFontSize
          el.style.borderWidth = this.contents.searchBtnBorderWidth
          el.style.borderStyle = this.contents.searchBtnBorderStyle
          el.style.borderColor = this.contents.searchBtnBorderColor
          el.style.borderRadius = this.contents.searchBtnBorderRadius
          el.style.backgroundColor = this.contents.searchBtnBgColor
        })
      })
    },
    
    // 新增、批量删除
    contentBtnAdAllStyleChange() {
      this.$nextTick(()=>{
        document.querySelectorAll('.form-content .ad .el-button--success').forEach(el=>{
          el.style.height = this.contents.btnAdAllHeight
          el.style.color = this.contents.btnAdAllAddFontColor
          el.style.fontSize = this.contents.btnAdAllFontSize
          el.style.borderWidth = this.contents.btnAdAllBorderWidth
          el.style.borderStyle = this.contents.btnAdAllBorderStyle
          el.style.borderColor = this.contents.btnAdAllBorderColor
          el.style.borderRadius = this.contents.btnAdAllBorderRadius
          el.style.backgroundColor = this.contents.btnAdAllAddBgColor
        })
        document.querySelectorAll('.form-content .ad .el-button--danger').forEach(el=>{
          el.style.height = this.contents.btnAdAllHeight
          el.style.color = this.contents.btnAdAllDelFontColor
          el.style.fontSize = this.contents.btnAdAllFontSize
          el.style.borderWidth = this.contents.btnAdAllBorderWidth
          el.style.borderStyle = this.contents.btnAdAllBorderStyle
          el.style.borderColor = this.contents.btnAdAllBorderColor
          el.style.borderRadius = this.contents.btnAdAllBorderRadius
          el.style.backgroundColor = this.contents.btnAdAllDelBgColor
        })
        document.querySelectorAll('.form-content .ad .el-button--warning').forEach(el=>{
          el.style.height = this.contents.btnAdAllHeight
          el.style.color = this.contents.btnAdAllWarnFontColor
          el.style.fontSize = this.contents.btnAdAllFontSize
          el.style.borderWidth = this.contents.btnAdAllBorderWidth
          el.style.borderStyle = this.contents.btnAdAllBorderStyle
          el.style.borderColor = this.contents.btnAdAllBorderColor
          el.style.borderRadius = this.contents.btnAdAllBorderRadius
          el.style.backgroundColor = this.contents.btnAdAllWarnBgColor
        })
      })
    },

    headerRowStyle({ row, rowIndex}){
      return {color: this.contents.tableHeaderFontColor}
    },
    headerCellStyle({ row, rowIndex}){
      return {backgroundColor: this.contents.tableHeaderBgColor}
    },
    // 表格按钮
    contentTableBtnStyleChange(){
      
    },
    // 分页
    contentPageStyleChange(){
      let arr = []

      if(this.contents.pageTotal) arr.push('total')
      if(this.contents.pageSizes) arr.push('sizes')
      if(this.contents.pagePrevNext){
        arr.push('prev')
        if(this.contents.pagePager) arr.push('pager')
        arr.push('next')
      }
      if(this.contents.pageJumper) arr.push('jumper')
      this.layouts = arr.join()
      this.contents.pageEachNum = 10
    },

    init () {
          this.$http({
            url: `option/xiangmufenlei/leixing`,
            method: "get"
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.xiangmuleixingOptions = data.data;
            } else {
              this.$message.error(data.msg);
            }
          });
    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 项目类型改变时的处理函数
    xiangmuleixingChange() {
      this.search();
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: 'id',
      }
          if(this.searchForm.xiangmumingcheng!='' && this.searchForm.xiangmumingcheng!=undefined){
            params['xiangmumingcheng'] = '%' + this.searchForm.xiangmumingcheng + '%'
          }
          if(this.searchForm.xiangmuleixing!='' && this.searchForm.xiangmuleixing!=undefined){
            params['xiangmuleixing'] = this.searchForm.xiangmuleixing
          }
      this.$http({
        url: "jianshenxiangmu/page",
        method: "get",
        params: params
      }).then(({ data }) => {
        console.log("jianshenxiangmu data",data);
        
        if (data && data.code === 0) {
          console.log("jianshenxiangmu data",data);
          this.dataList = data.data.list;
          this.totalPage = data.data.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id,type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.crossAddOrUpdateFlag = false;
      if(type!='info'){
        type = 'else';
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id,type);
      });
    },
    // 查看评论
    disscussListHandler(id,type) {
	this.$router.push({path:'/discussjianshenxiangmu',query:{refid:id}});
    },
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 删除
    deleteHandler(id) {
      var ids = id
        ? [Number(id)]
        : this.dataListSelections.map(item => {
            return Number(item.id);
          });
      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "jianshenxiangmu/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },

viewDetailsHandler(project) {
      const projectName = project.xiangmumingcheng;
      this.showFlag = false;
      this.detailViewFlag = true;
      this.getProjectDetails(projectName);
    },

    async getProjectDetails(projectName) {
      try {
        const projectResponse = await axios.get(`/api/jianshenxiangmu/${projectName}`);
        this.project = projectResponse.data;

        const coachesResponse = await axios.get(`/jianshenxiangmu/${projectName}/coaches`);
        console.log("coachesResponse",coachesResponse);
        this.coaches = coachesResponse.data;
      } catch (error) {
        this.$message.error('获取项目详情失败');
        console.error(error);
      }
    },

    backToList() {
      this.detailViewFlag = false;
      this.showFlag = true;
    },

    // 一键关联所有教练项目
    async createAllAssociations() {
      this.$confirm('确定要创建所有教练与健身项目的关联关系吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await this.$http({
            url: '/jiaolianjianshengxiangmu/create',
            method: 'post'
          });
          
          if (response.data) {
            this.$message({
              message: response.data,
              type: 'success',
              duration: 2000
            });
            // 刷新列表
            this.getDataList();
          }
        } catch (error) {
          console.error('一键关联失败:', error);
          this.$message.error('一键关联失败: ' + (error.response?.data || error.message));
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    }

  }

};
</script>
